export enum CardSubTypes {
	RECEIVE = "RECEIVE",
	TRANSFER = "TRANSFER",
}
